module.exports = __webpack_public_path__ + "media/images/category_icons/other-59bed5730f0009bd86039a1e9196d8e9.svg";